import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { Aroma } from "../models/aroma";
import { Drink } from "../models/drink";
import { smokingProtocol } from "../models/smoking_protokol";
import { SP_compact } from "../models/sp_list_entry";
import { SPList_Filter } from "../models/sp_list_sort.filter";
import { SP_tiny } from "../models/tiny_sp";
import { DisplayloadingService } from "./displayloading.service";
import { lastValueFrom } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SmokingprotocolService {
  private api = environment.apiUrl;
  private spList: SP_compact[] = [];
  private spUpdated = new Subject<SP_compact[]>(); //Rauchprotokoll
  private spCountUpdated = new Subject<number>(); //Rauchprotokollanzahl für navi
  private spCount = 0;
  private spListFilter = new Subject<SPList_Filter>();
  constructor(
    private http: HttpClient,
    private ls: DisplayloadingService,
  ) {}

  //gibt Subject als abbonierbares Observable zurück
  public getSPUpdateListener() {
    return this.spUpdated.asObservable();
  }
  //gibt Subject als abbonierbares Observable zurück
  public getSPCountUpdateListener() {
    return this.spCountUpdated.asObservable();
  }

  public setSPCount(spcount: number) {
    this.spCount = spcount;
    this.spCountUpdated.next(spcount);
  }
  /**
   *
   * @returns alle Getränke aus der Datenbank
   */
  getAllDrinks(): Observable<Drink[]> {
    return this.http.get<Drink[]>(`${this.api}/drinks/get_drinks.php`);
  }
  /**
   * Holt alle Getränke aus der Datenbank
   * Passt das laut Nutzern zu der Zigarre
   * wird recommended an Drink true sein
   * @param cigarId
   * @returns all drinks incl recom
   */
  getAllDrinksInclRecom(cigarId: number): Observable<Drink[]> {
    return this.http.post<Drink[]>(
      `${this.api}/drinks/get_drinks_with_recom.php`,
      { cigarId: cigarId },
    );
  }

  /**
   *
   * @returns alle Aromen aus der Datenbank
   */
  getAllAromas(): Observable<Aroma[]> {
    return this.http.get<Aroma[]>(`${this.api}/aromas/get_aromas.php`);
  }
  /**
   *
   * @param smokingProtocol
   * Rauchprotokoll in DB speichern inkl. Aromen, Drinks, Rating, ggf.
   * werden Parameter am Humidor-Eintrag geändert
   * @returns
   */
  saveProtocol(smokingProtocol: smokingProtocol): Observable<any> {
    const data = { smoking_protocol: smokingProtocol };
    console.log(smokingProtocol);
    this.setSPCount(this.spCount + 1);
    return this.http.post<smokingProtocol>(
      `${this.api}/smoking_protocol/sync_smoking_protocol_adv.php`,
      data,
    );
  }

  /**
   * Changes photo
   * @param sp
   * @returns photo
   */
  async changePhoto(sp: SP_compact): Promise<void> {
    console.log(sp);
    const data = { smoking_protocol: sp };
    this.http
      .post<any>(`${this.api}/smoking_protocol/update_sp_photo.php`, data)
      .subscribe(async (message) => {
        if (message.updated === true) {
          await this.ls.presentMessage(
            "smoking-protocol.image-changed",
            2000,
            "success",
          );
          await this.ls.hideLoading();
        } else {
          await this.ls.presentMessage(
            "smoking-protocol.image-notchanged",
            2000,
            "error",
          );
          await this.ls.hideLoading();
        }
      });
    return;
  }
  /**
   *
   * @param userId
   * Holt Liste von allen Rauchprotokollen des Benutzers als Observable
   * zurück und aktualisiert das Subject
   *
   */
  getUsersProtocols(): Promise<void> {
    this.ls.presentLoading().then(() => {
      this.http
        .get<
          SP_compact[]
        >(`${this.api}/smoking_protocol/get_user_protocols.php`)
        .subscribe((protocols) => {
          this.spList = protocols;
          this.spUpdated.next(this.spList);
          /*console.log("Anzahl SP:")
          console.log(protocols.length)*/
          this.setSPCount(protocols.length);
          this.ls.hideLoading();
        });
    });
    return;
  }
  /**
   * Rauchprotokoll löschen
   * Subject updaten
   * @param id
   */
  async deleteProtocol(id: number): Promise<void> {
    const data = { sp_id: id };
    this.ls.presentLoading().then(async () => {
      const delProt = await this.http.post<any>(
        `${this.api}/smoking_protocol/delete_sp.php`,
        data,
      );
      const deleted = await lastValueFrom(delProt);
      if (deleted.message === "deleted") {
        this.ls.presentMessage(
          "smoking-protocol-list.deleted",
          2000,
          "success",
        );
        //View Update ohne DB-Anfrage
        for (let i = 0; i < this.spList.length; i++) {
          if (this.spList[i].id === id) {
            this.spList.splice(i, 1);
            this.spUpdated.next(this.spList);
            break;
          }
        }
      } else {
        this.ls.presentMessage(
          "smoking-protocol-list.not-deleted",
          2000,
          "error",
        );
      }
    });
  }
  /**
   *
   * @param sortBy: name, date, or rating points
   * @param direction: boolean true=ascendant
   * Erhält Sortierungsparameter und gibt erzeugtes Filterobjekt für Pipe zurück
   *
   */
  async setProtocolFilter(
    sortBy: string,
    direction: boolean,
    searchString: string,
  ) {
    let filter: SPList_Filter = {
      filterBy: sortBy,
      direction: direction,
      searchString: searchString,
    };
    this.spListFilter.next(filter);
  }

  getProtocolFilter(): Observable<SPList_Filter> {
    return this.spListFilter.asObservable();
  }
  /**
   *
   * @param cigarId Id der Zigarre zu der Prots gesucht werden
   * @param max Anzahl der Protokolle, die maximal zurück gegeben werden sollen
   * @description
   * Schaut nach ob für die gegebene Zigarre(id)
   * bereits Protokolle erstellt wurden und gibt diese
   * als Array zurück
   *
   * @returns
   */
  public async getCigarProtocols(
    cigarId: number,
    max: number = 3,
  ): Promise<SP_tiny[]> {
    let protocols: SP_tiny[] = [];
    await this.ls.presentLoading();
    const result = await this.http
      .post<any>(`${this.api}/cigar/get_cigar_protocols.php`, {
        cigarId: cigarId,
        limit: max,
      })
      .toPromise();
    protocols = result.map((p) => {
      return {
        id: p.id,
        date: p.date,
        cigarAge: p.cigar_age,
        smokingTime: p.smokingTime,
        cigarStrength: p.cigar_strength,
        aromas: p.aromas,
        drink: p.drink,
        drinkFits: p.drinkFits,
      };
    });
    await this.ls.hideLoading();
    console.log(typeof protocols);
    console.log(protocols);
    return Promise.all(protocols);
  }

  public updateSmokingTime(
    protocolId: number,
    smokingTime: number,
    rpg: number,
  ): Observable<any> {
    return this.http.post<any>(`${this.api}/smoking_protocol/update_smoking_time.php`, {
      id: protocolId,
      smokingTime: smokingTime,
      rpg: rpg,
    });
  }
}
